import { HomeCpaData, parseApiErrorMessage } from '@liscio/api';
import { NavMenuItem, useHomeData } from '@liscio/common';
import {
  Avatar,
  GlobalLoader,
  Icon,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  useMenuAnchor,
} from '@liscio/ui';

import { useToastError } from 'custom-hooks';
import { useCpa } from 'stores/cpa';

export const CpaSelectorMenuItem = () => {
  const { anchorEl, open, onOpen: handleMenuClick, onClose } = useMenuAnchor();
  const { data: homeData } = useHomeData();
  const { switchCpa, isLoading, error: switchCpaError } = useCpa();

  useToastError(
    switchCpaError,
    parseApiErrorMessage(switchCpaError) || 'Error: Unable to change workspaces'
  );
  const handleMenuItemClick = async (newCpaData?: HomeCpaData) => {
    onClose();
    if (newCpaData?.custom_liscio_url) {
      await switchCpa(newCpaData.custom_liscio_url);
    }
  };

  if (!homeData || !homeData.cpa_data || homeData.cpa_data.length < 2) {
    return null;
  }

  const availableCpaList: HomeCpaData[] = homeData.cpa_data.filter(
    (cpa: HomeCpaData) => cpa.id !== homeData.data.cpa_id
  );

  return (
    <>
      <NavMenuItem
        icon={<Icon icon="user" />}
        label={homeData.data.cpa_name}
        onClick={handleMenuClick}
        role="button"
      />
      <Menu
        id="cpa-menu"
        aria-labelledby="cpa-menu-button"
        anchorEl={anchorEl}
        open={open}
        onClose={() => {
          handleMenuItemClick();
        }}
        anchorOrigin={{
          horizontal: 'right',
          vertical: 'top',
        }}
        transformOrigin={{ horizontal: 'left', vertical: 'top' }}
        sx={{ ml: 1 }}
      >
        {availableCpaList.map((cpa) => (
          <MenuItem
            key={cpa.name}
            onClick={() => {
              handleMenuItemClick(cpa);
            }}
          >
            <ListItemIcon>
              <Avatar
                src={cpa.logo}
                alt={cpa.name}
                sx={{ width: 20, height: 20, fontSize: '12px', border: 'none' }}
              />
            </ListItemIcon>
            <ListItemText>{cpa.name}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
      <GlobalLoader open={isLoading} />
    </>
  );
};
